import { useShowResponseStatus } from '@/shared';
import { useUpdatePaymentSystemMutation } from '../store/payment-system-api';
import { handlePaymentSystemUpdateError } from '../utils/helpers/payment-systems-errors';

import type { TPaymentSystemUpdateParams } from '../store/types';

export const useUpdatePaymentSystem = () => {
  const [updatePaymentSystem, { isLoading, isSuccess, error }] = useUpdatePaymentSystemMutation();
  const updateError = handlePaymentSystemUpdateError(error);

  useShowResponseStatus({
    isSuccess,
    successMessage: 'Платёжная система успешно обновлёна',
    error: updateError,
  });

  const handleEditPaymentSystem = async (params: { systemId: number; name: string; data: string; }) => {
    const newParams: TPaymentSystemUpdateParams = {
      ...params,
      data: JSON.parse(params.data),
    };

    await updatePaymentSystem(newParams);
  };

  return {
    handleEditPaymentSystem,
    updatePaymentSystem,
    isLoading,
  };
};
